import { render, staticRenderFns } from "./tv-configuration.vue?vue&type=template&id=379b6314&scoped=true&"
import script from "./tv-configuration.vue?vue&type=script&lang=ts&"
export * from "./tv-configuration.vue?vue&type=script&lang=ts&"
import style0 from "./tv-configuration.vue?vue&type=style&index=0&id=379b6314&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b6314",
  null
  
)

export default component.exports